<template>
  <div class="login-container">
    <div> <!---- class="login-box"-->
      <div class="row d-flex justify-content-center align-items-center h-100">
        <div class="col-md-9 col-lg-6 col-xl-5">
          <img src="@/assets/logo-app.png" class="img-fluid" alt="Login Image" />
        </div>
        <div class="col-md-8 col-lg-6 col-xl-4 offset-xl-1">
          <form @submit.prevent="login">
            <input v-model="credentials.username" placeholder="Username" class="input-field" />
            <input v-model="credentials.password" type="password" placeholder="Password" class="input-field" />
            <button type="submit" class="login-button">Login</button>
          </form>
        </div>
        <p v-if="error" class="error-message">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { AuthApi } from '../api';

export default {
  data() {
    return {
      credentials: {
        username: '',
        password: '',
      },
      error: '',
    };
  },
  methods: {
    async login() {
      try {
        localStorage.removeItem("authToken");
        // sessionStorage.removeItem("authToken");
        localStorage.removeItem("user");
        // sessionStorage.removeItem("user");

        const response = await AuthApi.login(this.credentials);
        console.log("token " + JSON.stringify(response))
        const { token, user } = response; // Extract token and user info

        // ✅ Store in localStorage (or sessionStorage)
        // const token = response.data.token; // Assuming your backend returns a token
        //const token = response; // Assuming your backend returns a token
        localStorage.setItem('authToken', token); // Store the token in localStorage
        localStorage.setItem("user", JSON.stringify(user));
        this.$router.push('/'); // Redirect to home page
      } catch (error) {
        this.error = 'Login failed. Please check your credentials.';
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f4f4f4;
}

.login-box {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 350px;
}

.logo {
  width: 100px;
  margin-bottom: 20px;
}

.input-field {
  width: 90%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.login-button {
  width: 90%;
  padding: 10px;
  background-color: #007bff;
  border: none;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.login-button:hover {
  background-color: #0056b3;
}

.img-fluid {
    max-width: 91%;
    height: auto;
}



.error-message {
  color: red;
  margin-top: 10px;
}
</style>
